import React, { useEffect, useState } from 'react';
import './index.module.less';
import NavBar from '@components/NavBar';
import CommonBtn from '@components/CommonBtn';
import SettingMenu from './SettingMenu';
import BrowserHistory from '@helpers/BrowserHistory';
import { Api } from '@apis/client';
import Http from '@helpers/Http';
import noPlace from './images/noPlace.png';
import { IPlaceItem } from './constants';
import useUrlParams from '@helpers/useUrlParams';
import FridayService from '@services/friday';

//私有常量

//可抽离的逻辑处理函数/组件

let LocationSettingFrequentedPlace = (_props: IProps) => {
  //变量声明、解构
  const params = useUrlParams();

  //组件状态
  const [place, setPlace] = useState<IPlaceItem[]>([]);
  const [selectPlace, setSelectPlace] = useState<IPlaceItem>(null);
  const [showMenu, setShowMenu] = useState(false);
  const [loading, setLoading] = useState(false);

  //网络IO
  // 获取孩子的常去地点
  const getFrequentedPlace = async () => {
    setLoading(true);
    const { data } = await Http.post(Api.GetMobileRegionStayV1, {
      snCode: params.snCode,
      company: params.company,
    });
    setLoading(false);
    setPlace(data);
  };

  //数据转换

  //逻辑处理函数
  const handleShowSettingMenu = (place: IPlaceItem) => {
    setShowMenu(true);
    setSelectPlace(place);
  };

  const toAddFrequentedPlace = () => {
    FridayService.addEvent(
      'real_time_positioning_more_positioning_settings_frequent_places_add_frequent_places_click',
    );
    setTimeout(() => {
      BrowserHistory.push(
        `${PUBLIC_URL}/mapFrequentedPlace?snCode=${params.snCode}&company=${params.company}&actionType=add`,
      );
    }, 100);
  };

  //组件Effect
  useEffect(() => {
    getFrequentedPlace();
    // eslint-disable-next-line
  }, []);

  return (
    <div styleName="container">
      <NavBar title="常去地点" transparent />
      {loading ? null : (
        <>
          {place.length > 0 ? (
            <>
              <div styleName="hint">
                设置常去地点，定位更准({place.length}/20)
              </div>
              <div styleName="main">
                <div styleName="frequented-place">
                  {place.map((item: IPlaceItem) => (
                    <div
                      styleName="place"
                      key={item?.uid}
                      onClick={() => handleShowSettingMenu(item)}
                    >
                      <div styleName="place-name">{item?.name}</div>
                      <i
                        styleName="arrow-right"
                        className="iconfont icon-tubiaoyanse"
                      />
                    </div>
                  ))}
                </div>
              </div>
            </>
          ) : (
            <div styleName="no-place">
              <img src={noPlace} alt="设置常去地点，定位更准~" />
              <div>设置常去地点，定位更准~</div>
            </div>
          )}
          <CommonBtn
            type="auto"
            btnText="添加常去地点"
            onConfirm={place.length < 20 ? toAddFrequentedPlace : null}
            style={{
              background: place.length < 20 ? '#1D70F2' : '#BED6FC',
              color: '#FFFFFF',
              fontSize: '.32rem',
              marginBottom: '.32rem',
              fontWeight: 500,
              borderRadius: '0.24rem',
            }}
          />
          {showMenu && (
            <SettingMenu
              place={selectPlace}
              onClose={() => setShowMenu(false)}
              onRequestData={getFrequentedPlace}
            />
          )}
        </>
      )}
    </div>
  );
};

//props类型定义
interface IProps {}

//prop-type定义，可选

export default LocationSettingFrequentedPlace;
